import { useQuery } from 'react-query'
import { message } from 'antd'
import { getApiRoles, getApiUsers } from 'utils/requests'
// helpers
import get from 'lodash/get'
import map from 'lodash/map'
import { useEffect } from 'react'

const useFetchData = (states, actions) => {
  const handlerRequest = useQuery<any>({
    queryKey: 'users-auth-data',
    queryFn: () =>
      getApiUsers({
        is_fraudulent: false,
        page: states.page,
        search: states.searchInput,
        limit: 9
      }),
    initialData: [],
    select: rawData => {
      return rawData.map(({ username, ...user }, i) => ({
        username,
        ...user,
        key: `${username}-${i}`
      }))

    },
    onSuccess: () => {
      actions.setDirtyBit(false)
    },
    onError: () => {
      actions.setDirtyBit(false)
      message.error({
        type: 'error',
        content: 'Algo ha salido mal'
      })
    }
  })

  const { } = useQuery<any>({
    queryKey: 'roles-data',
    select: (rawData) => map(rawData, ({ id, ...data }) => ({ id, key: id, ...data })),
    queryFn: () =>
      getApiRoles(),
    initialData: [],
    onSuccess: (data) => {
      actions.setRoles(data)
    },
    onError: () => {

    }
  })

  useEffect(() => {
    states.dirtyBit && handlerRequest.refetch()
  }, [states.dirtyBit])

  return handlerRequest
}

export default useFetchData
